import React from 'react';
import S from './story.styles';

const Story0 = ({
  prevColour = 'white',
  nextColour = 'red',
  color,
  children
}) => {
  return (
    <S.StoryContainer zIndex="3">
      <S.TransitionBlock prevColour={prevColour} nextColour={nextColour} />
      <S.ColouredBlock nextColour={nextColour} color={color}>
        {children}
      </S.ColouredBlock>
    </S.StoryContainer>
  );
};

export default Story0;
